import { useState, useEffect, useContext } from 'react';

import { LiveReserveContext } from '../../LiveLessonReseveContext';


// 習いたい箇所
function LiveReserveRequest() {

  const {
    requestContent, setRequestContent,
  } = useContext(LiveReserveContext);

  return (
    <div>

      <label
        className="control-label"
        style={{
          margin: '15px 0 10px 0',
          backgroundColor: '#eaffea',
          padding: '0.25em 3em 0.25em 0.5em',
          borderLeft: 'solid 5px #3c8c3c',
        }}
      >
        特に習いたい箇所を記入
      </label>

      <div style={{fontSize: '90%'}}>
        <textarea
          className="form-control"
          style={{ fontSize: '16px' }}  //16px未満の場合：iOSで拡大される
          name="memo"
          placeholder="重点的に教えてもらいたい箇所をなどございましたらご記入ください。&#13;「フリートーク３」「学習カウセリング」を選択される際は必ずご記入ください。"
          rows={5}
          value={requestContent}
          onChange={(e) => setRequestContent(e.target.value)}
        />
      </div>

    </div>
  );
}
  
export default LiveReserveRequest;